package com.narbase.letsgo.web.views.banners

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.web.dto.banners.BannerDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.banners.DeleteBannerEndpoint
import com.narbase.letsgo.web.routing.domain.admin.banners.GetBannersEndpoint
import com.narbase.letsgo.web.routing.domain.admin.banners.UpsertBannerEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class BannersManagementViewModel {

    val upsertUiState = Observable<BasicUiState>()
    val getBannersUiState = Observable<BasicUiState>()

    var banners: Array<BannerDto> = arrayOf()

    var pageNo = 0
    var pageSize = 20
    var searchTerm: String = ""
    var total = 0

    fun getBanners() {
        setUpsertUiStateToNull()
        basicNetworkCall(getBannersUiState) {
            val dto = GetBannersEndpoint.Request(pageNo, pageSize, searchTerm)
            val response = GetBannersEndpoint.remoteProcess(dto).data
            banners = response.list
            total = response.total
        }
    }

    fun searchFor(term: String) {
        pageNo = 0
        searchTerm = term
        getBannersUiState.value = BasicUiState.Loaded
        getBanners()
    }


    fun upsertItem(banner: BannerDto) {
        basicNetworkCall(upsertUiState) {
            val dto = UpsertBannerEndpoint.Request(
                id = banner.id,
                title = banner.title,
                description = banner.description,
                backgroundUrl = banner.backgroundUrl,
                isActive = banner.isActive
            )
            UpsertBannerEndpoint.remoteProcess(dto)
        }
    }

    fun deleteItem(bannerId: KmmLong) {
        basicNetworkCall(upsertUiState) {
            val dto = DeleteBannerEndpoint.Request(bannerId)
            DeleteBannerEndpoint.remoteProcess(dto)
        }
    }

    fun getNextPage() {
        pageNo++
        getBanners()
    }

    fun getPreviousPage() {
        pageNo--
        getBanners()
    }

    fun setUpsertUiStateToNull() {
        upsertUiState.value = null
    }
}